module.exports = __webpack_public_path__ + "static/media/air-h.ba6331eb.jpg";